import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const TooltipContainer = styled.div`
  box-sizing: border-box;
  border: ${pxToRem(1)} solid rgba(114, 82, 220, 0.4);
  border-radius: ${pxToRem(6)};
  background: rgba(114, 82, 220, 0.05);
  padding: ${pxToRem(6)} ${pxToRem(12)} ${pxToRem(6)} ${pxToRem(12)};
`;

export const TooltipDate = styled.p`
  color: rgb(114, 82, 220);
  font-size: ${pxToRem(8)};
  font-weight: 500;
  padding: 0;
  margin: 0;
`;

export const TooltipRow = styled.p`
  color: rgb(114, 82, 220);
  font-size: ${pxToRem(16)};
  font-weight: 700;
  padding: 0;
  margin: 0;
`;
